import React from 'react';

import { Menu } from '@base-ui/react/menu';
import { List, Paper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  paper: {
    // Opacity only — scale() on starting-style breaks Floating UI's first measurement
    '&[data-starting-style], &[data-ending-style]': {
      opacity: 0,
    },
    minWidth: 160,
    outline: 'none',
    paddingBlock: theme.spacing(0.5),
    transition: 'opacity 204ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
}));

export function DeclarativeMenuPopup(props: React.ComponentProps<typeof Menu.Popup>) {
  const { classes } = useStyles();

  return (
    <Menu.Popup
      render={renderProps => (
        <Paper className={classes.paper} elevation={8} {...renderProps}>
          <List disablePadding component="div">
            {props.children}
          </List>
        </Paper>
      )}
      {...props}
    />
  );
}
